// 柱状图
export function generateBarChartTooltip(option) {
  option = {
    ...{
      borderColor: "#eee",
      primaryColor: "#eee",
      name: "",
      value: "no data",
    },
    ...option,
  };
  return `
    <div class="tooltip" style="border-color: ${option.borderColor}">
        <span class="tooltip-dot" style="background-color: ${option.primaryColor}"></span>
        <span>${option.name}: </span>
        <span class="tooltip-value">${option.value}</span>
    </div>
  `;
}

// 饼图
export function generatePieChartTooltip(option) {
  option = {
    ...{
      borderColor: "#eee",
      primaryColor: "#eee",
      name: "",
      value: "no data",
      percent: 0,
    },
    ...option,
  };
  return `
    <div class="tooltip" style="border-color: ${option.borderColor}">
        <span class="tooltip-dot" style="background-color: ${option.primaryColor}"></span>
        <span>${option.name}: </span>
        <span class="tooltip-value">${option.value}</span>
        <span class="tooltip-percent">${option.percent}%</span>
    </div>
  `;
}

// 散点图
export function generateScatterChartTooltip(option) {
  option = {
    ...{
      borderColor: "#eee",
      primaryColor: "#eee",
      name: "",
      value: "no data",
    },
    ...option,
  };
  return `
    <div class="tooltip" style="border-color: ${option.borderColor}">
        <span class="tooltip-dot" style="background-color: ${option.primaryColor}"></span>
        <span>${option.name}: </span>
        <span class="tooltip-value">${option.value}</span>
    </div>
  `;
}

// 旭日图
export function generateSunburstChartTooltip(option) {
  option = {
    ...{
      borderColor: "#eee",
      primaryColor: "#eee",
      name: "",
      value: "no data",
    },
    ...option,
  };
  return `
    <div class="tooltip" style="border-color: ${option.borderColor}">
        <span class="tooltip-dot" style="background-color: ${option.primaryColor}"></span>
        <span>${option.name}: </span>
        <span class="tooltip-value">${option.value}</span>
    </div>
  `;
}

// 树状图
export function generateTreeChartTooltip(option) {
  option = {
    borderColor: "#eee",
    primaryColor: "#eee",
    name: "",
    value: "no data",
    ...option,
  };
  return `
    <div class="tooltip" style="border-color: ${option.borderColor}">
      <div>
        <span class="tooltip-dot" style="background-color: ${
          option.primaryColor
        }"></span>
        <span>${option.name}${option.value ? `: ${option.value}` : ""}</span>
      </div>
    </div>
  `;
}
